// extracted by mini-css-extract-plugin
export default {"asterisk":"Asterisk_asterisk__IueJb","space":"Asterisk_space__mBc9r","spin":"Asterisk_spin__QGQSK"};